import { consoleGroups, consoleSectionGroups, logsGroups } from "./accessGroups.mjs";

export default {
    title: "Console",
    icon: "mdi-console",
    groups: consoleSectionGroups,
    submenu: [
        {
            title: "Console",
            groups: consoleGroups,
            route: { name: "console" },
        },
        {
            title: "Logs",
            groups: logsGroups,
            route: { name: "logs" },
        },
    ],
};
